import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useAlert } from '../../../context/AlertContext';
import {PORTAL_MAP} from '../portalMap'
import portalServices from '../../portals/portalServices';


function SelectPortalPage() {
    const navigate = useNavigate();
    const { AppAlert } = useAlert();

    const [portalId, setPortalId] = useState("");
    const [selectedPortal, setSelectedPortal] = useState(null);

    // Check for existing portal on mount
    useEffect(() => {
        if (localStorage.getItem("portalUrl")) {
            navigate("/auth/login");
        }
    }, [navigate]);

    /*
    const handleVerify = () => {
        const details = PORTAL_MAP[portalId.trim()];
        if (details) {
            setSelectedPortal(details);
        } else {
            AppAlert("Invalid Portal Id", "error");
        }
    };
    */


    const handleVerify = () =>{
        setSelectedPortal(null);
        portalServices.verify({portalId:portalId}).then(res=>{
            console.log(res);
            
            if(res.error){
                AppAlert(res.message,"error");
            } else {
                setSelectedPortal(res.data);
            }
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        })
    }

    const confirmPortalSelection = useCallback(() => {
        if (!selectedPortal) return;

        localStorage.setItem("portalUrl", selectedPortal.url);
        localStorage.setItem("portalTitle", selectedPortal.title);
        localStorage.setItem("portalId", selectedPortal.portalId);
        
        // window.location.reload() is a hard reset. 
        // If your App.js reacts to localStorage, navigate() is smoother.
        window.location.reload(); 
    }, [selectedPortal]);

    const closeDialog = () => setSelectedPortal(null);

    return (
        <div className="container">
            <div className="row mt-5 justify-content-center">
                <div className='col-md-12 text-center'>
                    <img src='/erp.png' alt="Logo" style={{ width: "30%" }} />
                </div>
                
                <div className="col-md-12 mt-3">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <div className="text-center mb-4">
                                <span className="uniworldvision-logo"></span>
                            </div>
                            <div className="form-group">
                                <label className="form-label">Business Portal ID</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder="e.g. your business-location"
                                    value={portalId}
                                    onChange={(e) => setPortalId(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleVerify()}
                                />
                            </div>
                        </div>
                        <div className="card-footer bg-white border-0">
                            <button 
                                type="button" 
                                className="btn btn-danger float-end" 
                                onClick={handleVerify}
                            >
                                Verify
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={Boolean(selectedPortal)}
                onClose={closeDialog}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Confirm Selection</DialogTitle>
                <DialogContent>
                    <p className="text-muted">You have selected:</p>
                    <h4 className="fw-bold">{selectedPortal?.title}</h4>
                </DialogContent>
                <DialogActions className="p-3">
                    <button className="btn btn-light" onClick={closeDialog}>Cancel</button>
                    <button className="btn btn-success" onClick={confirmPortalSelection}>Continue</button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default SelectPortalPage;